function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M22.6,12.3c-2.8,0-5,2.3-5,5c0,2.8,2.3,5,5,5c2.8,0,5-2.3,5-5C27.7,14.6,25.4,12.3,22.6,12.3z M22.6,20.2 c-1.5,0-2.8-1.3-2.8-2.8c0-1.5,1.3-2.8,2.8-2.8c1.5,0,2.8,1.3,2.8,2.8C25.4,18.9,24.2,20.2,22.6,20.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.7,8.3c-2.5-2.5-5.7-3.8-9.2-3.8c-3.5,0-6.7,1.4-9.2,3.8c-4.5,4.5-5.1,13.1-1.2,18.2l10.4,15.1l10.4-15 C36.8,21.3,36.2,12.8,31.7,8.3z M22.5,37.6l-8.6-12.4c-3.3-4.4-2.8-11.5,1-15.3c2-2,4.7-3.2,7.6-3.2c2.9,0,5.6,1.1,7.6,3.2 c3.8,3.8,4.3,11,1,15.4L22.5,37.6z"
}));

var SvgMapIcon = function SvgMapIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "46px",
    viewBox: "0 0 45 46",
    style: {
      enableBackground: "new 0 0 45 46"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-icon.f2de0f0a.svg";
export { ForwardRef as ReactComponent };